var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 101,
    viewBox: "0 0 272 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 271,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.935 35.4365V57.1859H145.726V35.4365H141.935Z",
    fill: "#EEE5FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.571 63.3995V41.4643H108.835L109.146 43.2349H109.301C110.234 42.0221 111.818 41.1535 114.025 41.1535C118.063 41.1535 121.296 44.4476 121.296 49.3237C121.296 54.1997 118.065 57.4939 114.025 57.4939C111.849 57.4939 110.328 56.592 109.52 55.5679H109.365V63.3968H105.574L105.571 63.3995ZM117.502 49.3265C117.502 46.468 115.668 44.6669 113.431 44.6669C111.194 44.6669 109.359 46.468 109.359 49.3265C109.359 52.1849 111.194 53.986 113.431 53.986C115.668 53.986 117.502 52.1849 117.502 49.3265Z",
    fill: "#EEE5FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.219 49.3237C123.219 44.5697 126.635 41.1535 131.203 41.1535C135.771 41.1535 139.187 44.5697 139.187 49.3237C139.187 54.0776 135.771 57.4939 131.203 57.4939C126.635 57.4939 123.219 54.0443 123.219 49.3237ZM135.366 49.3237C135.366 46.5263 133.501 44.6641 131.203 44.6641C128.905 44.6641 127.01 46.529 127.01 49.3237C127.01 52.1183 128.905 53.9527 131.203 53.9527C133.501 53.9527 135.366 52.1211 135.366 49.3237Z",
    fill: "#EEE5FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.799 41.4643H163.837L157.001 60.5716C156.319 62.4671 155.386 63.3995 152.93 63.3995H149.264V59.8889H152.372C152.933 59.8889 153.241 59.6086 153.43 59.1424L153.802 58.1183L147.402 41.4643H151.44L155.511 52.3709H156.133L159.799 41.4643Z",
    fill: "#EEE5FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.413 57.9629H164.561C164.656 60.2303 166.706 63.7104 172.018 63.7104C176.772 63.7104 179.57 60.9435 179.57 56.7807V41.4643H176.275L175.965 43.1738H175.809C174.846 41.9916 173.323 41.1535 171.241 41.1535C167.203 41.1535 164.095 44.2284 164.095 48.702C164.095 53.1757 167.203 56.2839 171.241 56.2839C173.231 56.2839 174.785 55.4763 175.623 54.5744H175.779V56.7807C175.779 58.9564 174.286 60.3857 172.018 60.3857C169.593 60.3857 168.569 58.987 168.413 57.9629ZM171.832 44.542C174.039 44.542 175.779 46.2515 175.779 48.7048C175.779 51.1886 174.008 52.8981 171.832 52.8981C169.656 52.8981 167.916 51.1581 167.916 48.7048C167.916 46.2515 169.626 44.542 171.832 44.542Z",
    fill: "#EEE5FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.203 49.3237C182.203 44.5697 185.619 41.1535 190.187 41.1535C194.755 41.1535 198.172 44.5697 198.172 49.3237C198.172 54.0776 194.755 57.4939 190.187 57.4939C185.619 57.4939 182.203 54.0443 182.203 49.3237ZM194.35 49.3237C194.35 46.5263 192.485 44.6641 190.187 44.6641C187.89 44.6641 185.994 46.529 185.994 49.3237C185.994 52.1183 187.89 53.9527 190.187 53.9527C192.485 53.9527 194.35 52.1211 194.35 49.3237Z",
    fill: "#EEE5FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.811 57.1831V57.1859L200.808 57.1831H200.811Z",
    fill: "#EEE5FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M200.811 57.1831H204.599V48.2358C204.599 46.2793 206.153 44.7557 208.11 44.7557C210.066 44.7557 211.496 46.2154 211.496 48.2358V57.1831H215.286V47.739C215.286 43.7622 212.678 41.1535 209.073 41.1535C206.714 41.1535 205.16 42.2413 204.538 42.9546H204.383L204.072 41.4643H200.811V57.1831Z",
    fill: "#EEE5FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1702 58.5075L94.4894 53.1264C94.9834 52.8406 95.2887 52.3105 95.2887 51.7416V40.9793C95.2887 40.4104 94.9834 39.8803 94.4894 39.5945L85.1702 34.2133C84.6763 33.9275 84.0629 33.9303 83.5717 34.2133L74.2526 39.5945C73.7586 39.8803 73.4533 40.4104 73.4533 40.9793V60.2115L66.9177 63.983L60.3821 60.2115V52.6657L66.9177 48.8942L71.2276 51.3836V46.3216L67.7169 44.2929C67.4755 44.1542 67.198 44.0792 66.9177 44.0792C66.6374 44.0792 66.3599 44.1542 66.1184 44.2929L56.7993 49.674C56.3053 49.9599 56 50.49 56 51.0589V61.8211C56 62.3901 56.3053 62.9201 56.7993 63.206L66.1184 68.5871C66.6124 68.8702 67.223 68.8702 67.7169 68.5871L77.0361 63.206C77.5301 62.9201 77.8354 62.3901 77.8354 61.8211V42.5889L77.9519 42.5223L84.3682 38.8174L90.9038 42.5889V50.1347L84.3682 53.9062L80.0639 51.4224V56.4844L83.569 58.5075C84.0629 58.7906 84.6763 58.7906 85.1675 58.5075H85.1702Z",
    fill: "url(#paint0_linear_1909_60405)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1909_60405",
    x1: 55.8723,
    y1: 62.8757,
    x2: 93.6013,
    y2: 40.9765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A726C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#803BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B3FE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.82d27be298e1b0ee5207ee520073bc2c.svg";
export { ForwardRef as ReactComponent };